import React, { useEffect, useMemo, useState } from 'react';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import { TabProps } from '../../utils/tabProps';
import { useDispatch, useSelector } from 'react-redux';
import {
  listCatalogueDiamant,
  listStockTamponAlert,
  listStockTamponConfig,
  updateStockTampon,
} from '../../redux/slices/catalogue-diamant.slice';
import FeatherIcon from 'feather-icons-react';
import {
  listAllocationDiamant,
  listCloseDiamantAlerts,
  listOpenDiamantAlerts,
  updateDiamantAlert,
} from '../../redux/slices/stock-diamant.slice';

const BCrumb = [
  {
    to: '/app',
    title: 'Home',
  },
  {
    title: 'Stock Tampon & Alerts',
  },
];

const CDStockTmpAlertContainer = () => {
  const [sel_tab, set_sel_tab] = useState(0);
  const handleTabChange = (event, newValue) => {
    set_sel_tab(newValue);
  };
  return (
    <PageContainer title="Stock Tampon & Alerts" description="">
      {/* breadcrumb */}
      <Breadcrumb title="Stock Tampon & Alerts" items={BCrumb} />

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={sel_tab} onChange={handleTabChange}>
            <Tab label="Stock manquant" {...TabProps(0)} />
            <Tab label="Config Stock tampon" {...TabProps(1)} />
          </Tabs>
        </Box>
      </Box>

      {sel_tab === 0 && <StockManquantContainer />}
      {sel_tab === 1 && <CDStockTmpList />}
    </PageContainer>
  );
};

const CDStockTmpList = () => {
  const dispatch = useDispatch();
  const [search, set_search] = useState('');
  const [lst_catalogue, set_lst_catalogue] = useState([]);
  const [lst_catalogue_src, set_lst_catalogue_src] = useState([]);
  const [show_form, set_show_form] = useState(false);
  const [sel_item, set_sel_item] = useState(null);

  const load_data = () => {
    dispatch(listStockTamponConfig())
      .unwrap()
      .then((res) => {
        set_lst_catalogue(Array.isArray(res) ? res : []);
        set_lst_catalogue_src(Array.isArray(res) ? res : []);
      });
  };

  const filterData = () => {
    const res = lst_catalogue_src.filter((el) =>
      String(el?.sku).toLowerCase().includes(String(search).toLowerCase()),
    );
    set_lst_catalogue(res);
  };

  const onCloseForm = () => {
    set_sel_item(null);
    set_show_form(false);
  };

  const onDeleteStockTampon = (item) => {
    dispatch(
      updateStockTampon([
        {
          idCatalogueDia: item?.idCatalogueDia,
          st_min_stock: 0,
          is_st_actif: false,
        },
      ]),
    )
      .unwrap()
      .then((res) => {
        load_data();
      });
  };

  useEffect(() => {
    filterData();
  }, [search]);

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Card sx={{ borderRadius: 1, mx: 0 }}>
      <CardContent>
        <Grid container spacing={0}>
          <Grid item lg={12} py={1}>
            <Typography variant="h4" fontWeight={400} color={'primary.main'}>
              {'Configuration stock tampon diamants'}
            </Typography>
          </Grid>
          <Grid item lg={6} textAlign={'end'}>
            <TextField
              label="Recherche"
              fullWidth
              size="small"
              value={search}
              onChange={(e) => set_search(e?.target?.value)}
            />
          </Grid>

          <Grid item lg={6} textAlign={'end'}>
            <Button
              variant="outlined"
              color="success"
              type="submit"
              onClick={(e) => set_show_form(true)}
            >
              <FeatherIcon icon="plus" width="18" /> Ajouter
            </Button>
          </Grid>

          <Grid item lg={12} mt={2}>
            <TableContainer>
              <Table
                size="small"
                stickyHeader
                sx={{ '& .MuiTableCell-root': { borderLeft: '1px solid rgba(224, 224, 224, 1)' } }}
              >
                <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
                  <TableRow>
                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}>
                        SKU
                      </Typography>
                    </TableCell>

                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}>
                        Famille | Type | Forme
                      </Typography>
                    </TableCell>

                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}>
                        Stock Tampon (CTS)
                      </Typography>
                    </TableCell>
                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}></Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Array.isArray(lst_catalogue) &&
                    lst_catalogue.map((el) => (
                      <TableRow key={el?.sku}>
                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Box display={'flex'} px={2} sx={{ cursor: 'pointer' }}>
                            <Typography color="primary.main" variant="subtitle2" fontWeight="600">
                              {el?.sku}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Typography variant="subtitle2" fontWeight="500">
                            {' '}
                            {`${el?.famille} | ${el?.type_pierre} | ${el?.forme}`}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Typography variant="subtitle2" fontWeight="600" color={'danger.main'}>
                            {el?.st_min_stock}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Button
                            variant="text"
                            color="warning"
                            type="submit"
                            onClick={(e) => {
                              set_sel_item(el);
                              set_show_form(true);
                            }}
                          >
                            <FeatherIcon icon="edit" width="16" />
                          </Button>
                          <Button
                            variant="text"
                            color="error"
                            type="submit"
                            onClick={(e) => onDeleteStockTampon(el)}
                          >
                            <FeatherIcon icon="trash" width="16" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <CDStockTmpFormModal
            show={show_form}
            onClose={onCloseForm}
            sel_item={sel_item}
            load_data={load_data}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};

const CDStockTmpFormModal = ({ show, onClose, sel_item, load_data }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.catalogue_store);
  const [lst_catalogue, set_lst_catalogue] = useState([]);

  const [form_values, set_form_values] = useState({
    catalogue: null,
    st_min_stock: 1.0,
  });
  const onSubmit = () => {
    if (form_values?.catalogue && form_values?.st_min_stock) {
      dispatch(
        updateStockTampon([
          {
            idCatalogueDia: form_values?.catalogue?.idCatalogueDia,
            st_min_stock: Math.abs(Number(form_values?.st_min_stock).toFixed(3)),
            is_st_actif: true,
          },
        ]),
      )
        .unwrap()
        .then((res) => {
          set_form_values({
            catalogue: null,
            st_min_stock: 1.0,
          });
          load_data();
          onClose();
        })
        .catch((err) => console.log(err));
    }
  };

  const load_catalogue = () => {
    dispatch(listCatalogueDiamant())
      .unwrap()
      .then((res) => {
        set_lst_catalogue(Array.isArray(res) ? res : []);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    load_catalogue();
  }, []);

  useEffect(() => {
    set_form_values({
      catalogue: sel_item,
      st_min_stock: sel_item?.st_min_stock,
    });
  }, [sel_item]);

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={show}
    >
      <DialogTitle>
        <Typography variant="h5" color={'primary.main'}>
          Config stock tampon
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        {error && (
          <Alert variant="filled" severity="error" sx={{ my: 1 }}>
            {error}
          </Alert>
        )}
        <Grid container spacing={1}>
          <Grid item lg={12}>
            <Typography>SKU</Typography>
            {sel_item ? (
              <TextField disabled size="small" fullWidth type="text" value={sel_item?.sku} />
            ) : (
              <Autocomplete
                options={Array.isArray(lst_catalogue) ? lst_catalogue : []}
                getOptionLabel={(el) => (el ? `${el?.sku} (${el?.famille})` : '')}
                onChange={(event, newValue) => {
                  return set_form_values({ ...form_values, catalogue: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="SKU/Nom ..."
                    aria-label="pierre"
                  />
                )}
              />
            )}
          </Grid>

          <Grid item lg={12}>
            <Typography>Stock tampon (CTS)</Typography>
            <TextField
              disabled={loading}
              size="small"
              fullWidth
              type="number"
              value={form_values?.st_min_stock}
              onChange={(e) =>
                set_form_values({
                  ...form_values,
                  st_min_stock: e?.target?.value,
                })
              }
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          color="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Fermer
        </Button>
        <Button variant="contained" color="success" onClick={onSubmit} disabled={loading}>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const StockManquantContainer = () => {
  const [sel_tab, set_sel_tab] = useState(0);
  const handleTabChange = (event, newValue) => {
    set_sel_tab(newValue);
  };
  return (
    <>
      <Box sx={{ width: '100%', pt: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={sel_tab} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Commande" {...TabProps(0)} />
            <Tab label="Stock tampon" {...TabProps(1)} />
            <Tab label="Stock allocation" {...TabProps(1)} />
          </Tabs>
        </Box>
      </Box>
      {sel_tab === 0 && <StockCommandeManquantList />}
      {sel_tab === 1 && <StockTamponManquantList />}
      {sel_tab === 2 && <StockDiamantAllocationTable />}
    </>
  );
};

const StockTamponManquantList = () => {
  const dispatch = useDispatch();
  const [search, set_search] = useState('');
  const [lst_catalogue, set_lst_catalogue] = useState([]);
  const [lst_catalogue_src, set_lst_catalogue_src] = useState([]);
  const load_catalogue_manquant = () => {
    dispatch(listStockTamponAlert())
      .unwrap()
      .then((res) => {
        set_lst_catalogue(Array.isArray(res) ? res : []);
        set_lst_catalogue_src(Array.isArray(res) ? res : []);
      })
      .catch((err) => console.log(err));
  };

  const filterData = () => {
    const res = lst_catalogue_src.filter((el) =>
      String(el?.sku).toLowerCase().includes(String(search).toLowerCase()),
    );
    set_lst_catalogue(res);
  };

  useEffect(() => {
    load_catalogue_manquant();
  }, []);

  useEffect(() => {
    filterData();
  }, [search]);

  return (
    <Card sx={{ borderRadius: 1, mx: 0 }}>
      <CardContent>
        <Grid container spacing={0}>
          <Grid item lg={6} textAlign={'end'}>
            <TextField
              label="Recherche"
              fullWidth
              size="small"
              value={search}
              onChange={(e) => set_search(e?.target?.value)}
            />
          </Grid>

          <Grid item lg={12} mt={2}>
            <TableContainer>
              <Table
                size="small"
                stickyHeader
                sx={{ '& .MuiTableCell-root': { borderLeft: '1px solid rgba(224, 224, 224, 1)' } }}
              >
                <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
                  <TableRow>
                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}>
                        SKU
                      </Typography>
                    </TableCell>

                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}>
                        Famille | Type | Forme
                      </Typography>
                    </TableCell>

                    <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                      <Typography variant="subtitle2" fontWeight={500}>
                        Poids Actuel (CTS) / Poids tampon (CTS)
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Array.isArray(lst_catalogue) &&
                    lst_catalogue.map((el) => (
                      <TableRow key={el?.sku}>
                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Box display={'flex'} px={2} sx={{ cursor: 'pointer' }}>
                            <Typography color="primary.main" variant="subtitle2" fontWeight="600">
                              {el?.sku}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Typography variant="subtitle2" fontWeight="500">
                            {' '}
                            {`${el?.famille} | ${el?.type_pierre} | ${el?.forme}`}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                          <Typography variant="subtitle2" fontWeight="500">
                            <Typography component={'span'} color={'danger.main'} fontWeight={'600'}>
                              {el?.stock_cts_total}
                            </Typography>
                            / {el?.st_min_stock}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const StockCommandeManquantList = () => {
  const dispatch = useDispatch();
  const [lst_alert, set_lst_alert] = useState([]);
  const [lst_alert_src, set_lst_alert_src] = useState([]);
  const [search, set_search] = useState('');
  const [archive_mode, set_archive_mode] = useState(false);

  const load_data = () => {
    if (archive_mode)
      dispatch(listCloseDiamantAlerts())
        .unwrap()
        .then((res) => {
          set_lst_alert(Array.isArray(res) ? res : []);
          set_lst_alert_src(Array.isArray(res) ? res : []);
        })
        .catch((err) => console.log(err));
    else
      dispatch(listOpenDiamantAlerts())
        .unwrap()
        .then((res) => {
          set_lst_alert(Array.isArray(res) ? res : []);
          set_lst_alert_src(Array.isArray(res) ? res : []);
        })
        .catch((err) => console.log(err));
  };

  const onResolve = (el) => {
    dispatch(updateDiamantAlert({ idAlert: el?.idAlert, is_resolved: true }))
      .unwrap()
      .then((res) => {
        load_data();
      })
      .catch((err) => console.log(err));
  };
  const onUnresolve = (el) => {
    dispatch(updateDiamantAlert({ idAlert: el?.idAlert, is_resolved: false }))
      .unwrap()
      .then((res) => {
        load_data();
      })
      .catch((err) => console.log(err));
  };

  const filterData = () => {
    const res = lst_alert_src.filter(
      (el) =>
        String(el?.catalogueDia?.sku).toLowerCase().includes(String(search).toLowerCase()) ||
        String(el?.fournisseur?.nomSociete).toLowerCase().includes(String(search).toLowerCase()) ||
        String(el?.num_commande).toLowerCase().includes(String(search).toLowerCase()),
    );
    set_lst_alert(res);
  };

  useEffect(() => {
    load_data();
  }, [archive_mode]);

  useEffect(() => {
    filterData();
  }, [search]);

  return (
    <Paper sx={{ width: '100%', p: 4, mt: 1 }}>
      <Grid container spacing={0}>
        <Grid item lg={6} textAlign={'end'}>
          <TextField
            label="Recherche"
            fullWidth
            size="small"
            value={search}
            onChange={(e) => set_search(e?.target?.value)}
            placeholder="RECHERCHE PAR (SKU, FOURNISSEUR, NUM COMMANDE)"
          />
        </Grid>
        <Grid item lg={6} textAlign={'end'}>
          <FormControlLabel
            control={
              <Switch
                checked={archive_mode}
                onChange={(e) => set_archive_mode(e?.target?.checked)}
                color="primary"
              />
            }
            label={'Archive'}
          />
        </Grid>

        <Grid item lg={12} mt={2}>
          <TableContainer>
            <Table
              size="small"
              stickyHeader
              sx={{ '& .MuiTableCell-root': { borderLeft: '1px solid rgba(224, 224, 224, 1)' } }}
            >
              <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
                <TableRow>
                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      SKU
                    </Typography>
                  </TableCell>

                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      Famille | Type | Forme
                    </Typography>
                  </TableCell>

                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      Commande
                    </Typography>
                  </TableCell>

                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      Poids Manquant (CTS)
                    </Typography>
                  </TableCell>

                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      Fournisseur
                    </Typography>
                  </TableCell>

                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      status
                    </Typography>
                  </TableCell>
                  <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
                    <Typography variant="subtitle2" fontWeight={500}>
                      ...
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Array.isArray(lst_alert) &&
                  lst_alert.map((el) => (
                    <TableRow key={el?.sku}>
                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        <Box display={'flex'} px={2} sx={{ cursor: 'pointer' }} flexDirection={'column'}>
                          
                          <Typography color="primary.main" variant="subtitle2" fontWeight="600">
                            {el?.catalogueDia?.sku}
                          </Typography>
                          <Chip
                            sx={{ mt: 0, borderRadius: 1 }}
                            size="small"
                            label={el?.type_alert === 'TRANSFER_REQUIRED' ? 'TRANSFERT REQUIS' : 'ACHAT REQUIS'}
                            color={
                              el?.type_alert === 'TRANSFER_REQUIRED' ? 'info' : 'error'
                            }
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        <Typography variant="subtitle2" fontWeight="500">
                          {' '}
                          {`${el?.catalogueDia?.famille} | ${el?.catalogueDia?.type_pierre} | ${el?.catalogueDia?.forme}`}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        <Typography variant="subtitle2" fontWeight="500">
                          {el?.num_commande}
                        </Typography>
                        <Chip
                          sx={{ mt: 0, borderRadius: 1 }}
                          size="small"
                          label={el?.type_commande}
                          color={el?.type_commande === 'commande-client' ? 'success' : 'secondary'}
                        />
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        <Typography variant="subtitle2" fontWeight="500" color={'danger.main'}>
                          {el?.poids_manquant_cts}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        <Typography variant="subtitle2" fontWeight="500" color={'primary.main'}>
                          {el?.fournisseur?.nomSociete}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        {el?.is_resolved ? (
                          <Chip
                            sx={{ mt: 0, borderRadius: 1 }}
                            size="small"
                            label="RESOLU"
                            color="success"
                          />
                        ) : (
                          <Chip
                            sx={{ mt: 0, borderRadius: 1 }}
                            size="small"
                            label="NON-RESOLU"
                            color="error"
                          />
                        )}
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center', minWidth: 200 }}>
                        {!el?.is_resolved ? (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => onResolve(el)}
                            size="small"
                          >
                            Resoudre
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => onUnresolve(el)}
                            size="small"
                          >
                            Réouvrir
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Paper>
  );
};

const StockDiamantAllocationTable = () => {
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();
  const [data, set_data] = useState([]);

  const load_data = () => {
    dispatch(listAllocationDiamant())
      .unwrap()
      .then((res) => {
        set_data(Array.isArray(res) ? res : []);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    load_data();
  }, []);

  const filteredData = useMemo(() => {
    if (!search) return data;

    const lowerSearch = search.toLowerCase();

    return data.filter((row) => {
      return (
        (row.refCmd && row.refCmd.toLowerCase().includes(lowerSearch)) ||
        (row.sku && row.sku.toLowerCase().includes(lowerSearch)) ||
        (row.nomSociete && row.nomSociete.toLowerCase().includes(lowerSearch)) ||
        (row.poids_alloue_cts && row.poids_alloue_cts.toString().includes(lowerSearch))
      );
    });
  }, [search, data]);

  return (
    <Box>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search Commande, SKU, Nom Fabricant, Poids..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Commande</strong>
              </TableCell>
              <TableCell>
                <strong>Sku</strong>
              </TableCell>
              <TableCell>
                <strong>Fabricant</strong>
              </TableCell>
              <TableCell align="right">
                <strong>Poids alloué (CTS)</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((row) => (
                <TableRow key={row.idStockDiamantAllocation}>
                  <TableCell>
                    <Typography color="primary" fontWeight={500}>
                      {row.refCmd || '-'}
                    </Typography>
                  </TableCell>

                  <TableCell>{row.sku}</TableCell>

                  <TableCell>{row.nomSociete}</TableCell>

                  <TableCell align="right">
                    <Typography color="error" fontWeight={600}>
                      {Number(row.poids_alloue_cts || 0).toFixed(3)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No results found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CDStockTmpAlertContainer;
